import Header from "./Header";
import Sidebar from "./Sidebar";
import Grid from "@material-ui/core/Grid";
import { useManagementLayoutStyles } from "./styles";
import BreadcrumbProvider from "../../../contexts/breadcrumb";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";
import { usePermission } from "../../../hooks/usePermission";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";
import { useEffect } from "react";

type ManagementLayoutProps = {
    children: React.ReactNode;
};

export default function ManagementLayout({ children }: ManagementLayoutProps) {
    const history = useHistory();
    const { isAuthUserLoading } = useAuth();
    const { isAboveAttendant } = usePermission();
    const { classes } = useManagementLayoutStyles();

    useEffect(() => {
        if (!isAuthUserLoading && (
            isAboveAttendant !== undefined
            && !isAboveAttendant
        )) {
            history.push("/");
        }
    }, [isAuthUserLoading, isAboveAttendant, history]);

    if (isAuthUserLoading) {
        return (
            <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <BreadcrumbProvider>
            <Grid container spacing={0} className={classes.root} wrap="nowrap">
                <Sidebar />
                <Grid xs item container spacing={0} direction="column" wrap="nowrap">
                    <Header />
                    <Grid xs item className={classes.content}>
                        {children}
                    </Grid>
                </Grid>
            </Grid>
        </BreadcrumbProvider>
    );
}
